import Container from "../Container";
import Checked from "../../designSystem/icons/Checked";
import React from "react";
import Title from "../../designSystem/Title";
import Text from "../../designSystem/Text";
import SimpleIndicator from "../../designSystem/SimpleIndicator";

export interface ConfirmationRecapProps {
    EMAIL: string,
    NO_LICENCE: string,
    ANNEE_LICENCE: number,
    VALIDITY_START: Date,
    VALIDITY_END: Date,
}

const ConfirmationRecap = (props: ConfirmationRecapProps) => {
    return (
        <Container>
            <div className={"flex flex-col items-center gap-y-4"}>
                <div className={"h-8 w-8"}><Checked /></div>
                <Title>Licence enregistrée !</Title>
                <Text className={"text-center"}>{`Une confirmation par e-mail a été envoyée à l’adresse ${props.EMAIL}, vous y retrouverez vos identifiants pour vous connecter à votre espace licencié et récupérer la carte de licencié.`}</Text>
                <div className={"flex w-full gap-x-8 justify-around wrap"}>
                    {props.NO_LICENCE &&
                        <SimpleIndicator title={"N° Licence"} value={props.NO_LICENCE} />
                    }
                    <SimpleIndicator
                        title={"Validité"}
                        value={`du ${props.VALIDITY_START.toLocaleDateString('fr-FR')} au ${props.VALIDITY_END.toLocaleDateString('fr-FR')}`}
                    />
                </div>
            </div>
        </Container>
    );
}

export default ConfirmationRecap;